import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from 'vue-router/composables';

import { Domain, buildUrlForDomain } from '@/routing/helpers/subdomain-helper';
import type { PageListItem } from '@/components/nav/static-pages/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'PagesList',
  props: {
    pages: { default: () => [] },
    activeDomain: null
  },
  emits: ['dismiss'],
  setup(__props: any, { emit }) {

const { activeDomain } = __props as { pages: PageListItem[], activeDomain?: Domain };





const router = useRouter();

function getHref(page: PageListItem) {
	if (page.external) return page.fullPath;

	return `https://www.${JW_CONFIG.DOMAIN}${page.fullPath}`;
}

async function go(path: string, external: boolean, openInNewTab = false) {
	if (!process.client) return;

	if (external) {
		if (openInNewTab) {
			window.open(path, '_blank', 'noopener');
		} else {
			window.open(path, '_self', 'noopener');
		}
	} else if (activeDomain !== Domain.MAIN) {
		// We're on a subdomain, need to redirect to main domain
		const targetUrl = buildUrlForDomain(path, Domain.MAIN);
		window.open(targetUrl, '_self', 'noopener');
	} else {
		router.push({ path });
	}

	emit('dismiss');
}

return { __sfc: true,activeDomain, emit, router, getHref, go }
}

})